import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  ActivatedRoute,
} from "@angular/router";
import { Observable, Subject } from "rxjs";
import { AuthServiceService } from "../services/auth-service.service";
import { ToastrService } from "ngx-toastr";
import { JwtHelperService } from "@auth0/angular-jwt";
import { GsdRoles } from "../enums/gsdRoles.enum";
import { MAINTENANCE_ERROR_CODES } from "../consts/appErrorCodes.const";
const jwtHelper = new JwtHelperService();

@Injectable({
  providedIn: "root",
})
export class LoginGuard implements CanActivate {
  public loader$ = new Subject<boolean>();
  roles: string;
  competencyLeaderRole: boolean;
  LeadershipRole: boolean;

  constructor(
    private auth: AuthServiceService,
    public router: Router,
    private authService: AuthServiceService,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.loader$.next(false);
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    this.loader$.next(true);
    var id_token = this.router.getCurrentNavigation().extractedUrl.fragment
    if (id_token && id_token.includes('id_token')) {
      let adToken = id_token.split('=');
      if (adToken && adToken[1]) {
        let token = adToken[1];
        const JWTtoken = jwtHelper.decodeToken(token);
        let reqBody = {
          userEmail: JWTtoken.unique_name,
          id_token: token.split('&')[0],
          clientName: 'Microsoft'
        }
        this.authService.getToken(reqBody).subscribe(res => {
          // this.loading = false;
          if (res.body) {
            this.authService.setLocalstorage(res.body, null);
            localStorage.setItem("MsSSOToken", reqBody.id_token);
            let redirectTo = localStorage.getItem('redirectTo')
            this.roles = this.auth.getRole();
            if (this.roles.includes(GsdRoles.CompetencyLeader) || this.roles.includes(GsdRoles.SubCompetencyLeader) || this.roles.includes(GsdRoles.SuperAdmin) || this.roles.includes(GsdRoles.Admin)) {
              this.competencyLeaderRole = true;
            } if (this.roles.includes(GsdRoles.Leadership)) {
              this.LeadershipRole = true;
            }
            this.loader$.next(false);
            if(this.roles.includes(GsdRoles.PMORole)){
              return this.router.navigate(['/Home/Timesheet Management'])
            }
            if (redirectTo)
              this.router.navigate([redirectTo])
            else if (this.competencyLeaderRole || this.LeadershipRole) {
              this.router.navigate(['/Home'])

            }
            else {
              this.router.navigate(['/Dashboard'])
            }
            this.loader$.next(false);
          }

        }, err => {
          this.loader$.next(false);
          if (MAINTENANCE_ERROR_CODES.includes(err.status)) {
            console.error('Error:', err)
            this.router.navigate(['/maintenance']);
          } else {
            this.router.navigate(['/login']);
            this.toastr.error(err.error);
          }
        });
      }

    }

    // if (Object.keys(queryParams).indexOf('access_token') != -1) {
    //   const sso_accesstoken = queryParams.access_token
    //   this.authService.getToken(sso_accesstoken).subscribe(res => {
    //     // this.loading = false;
    //     this.authService.setLocalstorage(res.body,sso_accesstoken);
    //     let redirectTo = localStorage.getItem('redirectTo')
    //     this.loader$.next(false);
    //     if (redirectTo)
    //       this.router.navigate([redirectTo])
    //     else this.router.navigate(['/Dashboard'])
    //     this.loader$.next(false);

    //   }, err => {
    //     this.loader$.next(false);
    //     this.router.navigate(['/login']);
    //     this.toastr.error(err.error);
    //   });
    // }

    else if (this.auth.isAuthenticated()) {
      this.loader$.next(false)
      let redirectTo = localStorage.getItem('redirectTo')
      if (redirectTo)
        this.router.navigate([redirectTo]);
      else this.router.navigate(['/Home']);
    }
    else {
      this.loader$.next(false)
      return true;
    }
  }
}
